export enum BloodTransfusionOptions {
  YES = 'Sim',
  NO = 'Não',
  NOT_INFORMED = 'Não informado'
}

export const bloodTransfusionOptions = [
  {
    label: 'Sim',
    value: BloodTransfusionOptions.YES,
    booleanValue: true
  },
  {
    label: 'Não',
    value: BloodTransfusionOptions.NO,
    booleanValue: false
  }
]
